import React from "react";
import imagemSoLogo from "../../assets/images/loading.gif";
export function Loading() {
  return (
    <div
      className="modal fade show"
      id="modal-overlay"
      style={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog">
        <div className="overlay">
          <div>
            <img
              alt="Carregando.."
              src={imagemSoLogo}
              style={{ height: 100, filter: "hue-rotate(15deg)" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
